export default __webpack_public_path__ + "static/barfplan-blog-promo-small@2x-8fbf0dbf11744cc8e6b997d8329143b0.png";